"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEDIA_REFERENCE_PATTERN = void 0;
exports.findMediaReferences = findMediaReferences;
const jsonpath_plus_1 = require("jsonpath-plus");
const types_1 = require("./IORepresentation/chatML/types");
// Matches the format parsed by MediaReferenceStringSchema.
exports.MEDIA_REFERENCE_PATTERN = /@@@langfuseMedia:.+?@@@/g;
/**
 * Scans a JSON value for `@@@langfuseMedia:...@@@` reference strings and
 * returns each occurrence with the JSONPath of the containing string.
 * References must be the entire string value; references embedded in
 * surrounding text and malformed references are ignored.
 */
function findMediaReferences(value) {
    // Dataset item fields are arbitrary JSON, so the root may itself be a reference
    if (typeof value === "string") {
        const reference = parseReference(value, "$");
        return reference ? [reference] : [];
    }
    if (typeof value !== "object" || value === null)
        return [];
    // The @string() type selector needs no filter expression, so script
    // evaluation can stay disabled. MediaReferenceStringSchema decides which
    // strings are references.
    const nodes = (0, jsonpath_plus_1.JSONPath)({
        path: "$..*@string()",
        json: value,
        resultType: "all",
        eval: false,
    });
    return nodes
        .map((node) => parseReference(node.value, node.path))
        .filter((reference) => reference !== null);
}
function parseReference(value, jsonPath) {
    const parsed = types_1.MediaReferenceStringSchema.safeParse(value);
    return parsed.success ? { ...parsed.data, jsonPath } : null;
}
